import React from 'react';
import { Figure1 } from './components/Figure1';
import { Figure2 } from './components/Figure2';
import { Figure3 } from './components/Figure3';
import { Figure4 } from './components/Figure4';
import { Figure5 } from './components/Figure5';
import { Figure6 } from './components/Figure6';
import { Figure7 } from './components/Figure7';
import { Figure8 } from './components/Figure8';
export function App() {
  return <div className="w-full min-h-screen bg-[#FBFAF6] py-12 px-4 md:px-8" data-id="element-0">
      <div className="max-w-[1100px] mx-auto" data-id="element-1">
        {/* Document header */}
        <header className="mb-10 border-b-2 border-[#1B1B1B] pb-8" data-id="element-2">
          <div className="flex items-baseline justify-between flex-wrap gap-3 mb-4" data-id="element-3">
            <div className="font-sans text-[10px] tracking-[0.2em] uppercase text-[#8B2500] font-bold" data-id="element-4">
              IB Diploma Programme · Physics · Extended Essay
            </div>
            <div className="font-sans text-[10px] tracking-[0.2em] uppercase text-[#5B5448]" data-id="element-5">
              Figures supplement · 8 plates
            </div>
          </div>
          <h1 className="font-serif text-[32px] md:text-[38px] font-bold text-[#1B1B1B] leading-[1.1] tracking-tight" data-id="element-6">
            Steam-Driven Generator: A Geothermal Energy Model
          </h1>
          <p className="font-serif text-[16px] italic text-[#5B5448] mt-3 max-w-3xl" data-id="element-7">
            Quantifying the gap between Carnot-theoretical and real-measured
            electrical efficiency in a laboratory analogue of a geothermal
            binary-cycle power plant.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 font-sans text-[12px]" data-id="element-8">
            <div data-id="element-9">
              <div className="text-[10px] uppercase tracking-wider text-[#5B5448] font-semibold" data-id="element-10">
                Candidate
              </div>
              <div className="text-[#1B1B1B] font-semibold mt-0.5" data-id="element-11">
                Akramjonov Javohir
              </div>
            </div>
            <div data-id="element-12">
              <div className="text-[10px] uppercase tracking-wider text-[#5B5448] font-semibold" data-id="element-13">
                Subject
              </div>
              <div className="text-[#1B1B1B] font-semibold mt-0.5" data-id="element-14">
                Physics (Higher Level)
              </div>
            </div>
            <div data-id="element-15">
              <div className="text-[10px] uppercase tracking-wider text-[#5B5448] font-semibold" data-id="element-16">
                Research focus
              </div>
              <div className="text-[#1B1B1B] font-semibold mt-0.5" data-id="element-17">
                Geothermal energy conversion
              </div>
            </div>
            <div data-id="element-18">
              <div className="text-[10px] uppercase tracking-wider text-[#5B5448] font-semibold" data-id="element-19">
                Variables
              </div>
              <div className="text-[#1B1B1B] font-semibold mt-0.5" data-id="element-20">
                T_hot ∈ [60, 100] °C, n = 3
              </div>
            </div>
          </div>
        </header>

        {/* Table of figures */}
        <nav className="mb-10 bg-white border border-[#E5E0D6] rounded-sm p-6" data-id="element-21">
          <div className="font-sans text-[10px] uppercase tracking-[0.2em] text-[#5B5448] font-semibold mb-3" data-id="element-22">
            List of figures
          </div>
          <ol className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1.5 font-serif text-[13px] text-[#1B1B1B]" data-id="element-23">
            <li data-id="element-24">
              <span className="text-[#8B2500] font-semibold mr-2" data-id="element-25">Fig. 1</span>
              Effect of T_hot on total electrical energy output
            </li>
            <li data-id="element-26">
              <span className="text-[#8B2500] font-semibold mr-2" data-id="element-27">Fig. 2</span>
              Carnot efficiency as a function of T_hot
            </li>
            <li data-id="element-28">
              <span className="text-[#8B2500] font-semibold mr-2" data-id="element-29">Fig. 3</span>
              Time-varying power P(t) at three temperatures
            </li>
            <li data-id="element-30">
              <span className="text-[#8B2500] font-semibold mr-2" data-id="element-31">Fig. 4</span>
              Carnot vs real efficiency comparison
            </li>
            <li data-id="element-32">
              <span className="text-[#8B2500] font-semibold mr-2" data-id="element-33">Fig. 5</span>
              Energy conversion chain (waterfall)
            </li>
            <li data-id="element-34">
              <span className="text-[#8B2500] font-semibold mr-2" data-id="element-35">Fig. 6</span>
              Trapezoidal Rule applied to P(t) at 80 °C
            </li>
            <li data-id="element-36">
              <span className="text-[#8B2500] font-semibold mr-2" data-id="element-37">Fig. 7</span>
              Mean E_out with uncertainty analysis
            </li>
            <li data-id="element-38">
              <span className="text-[#8B2500] font-semibold mr-2" data-id="element-39">Fig. 8</span>
              Lab model vs real-world geothermal plants
            </li>
          </ol>
        </nav>

        {/* Figures */}
        <main className="space-y-10" data-id="element-40">
          <Figure1 data-id="element-41" />
          <Figure2 data-id="element-42" />
          <Figure3 data-id="element-43" />
          <Figure4 data-id="element-44" />
          <Figure5 data-id="element-45" />
          <Figure6 data-id="element-46" />
          <Figure7 data-id="element-47" />
          <Figure8 data-id="element-48" />
        </main>

        {/* Footer */}
        <footer className="mt-16 pt-6 border-t border-[#E5E0D6] flex items-center justify-between font-sans text-[10px] text-[#5B5448]" data-id="element-49">
          <span data-id="element-50">
            © Akramjonov Javohir · IB Physics EE · Figures supplement
          </span>
          <span className="italic" data-id="element-51">
            Color palette: crimson #8B2500 · navy #1A4A68 · forest #2E5E28 ·
            amber #EF9F27
          </span>
        </footer>
      </div>
    </div>;
}